__turbopack_context__.v({
  "freeTokensAlert": "tooltip-free-tokens-module-scss-module__bQE2EG__freeTokensAlert",
});
